import { render, staticRenderFns } from "./oldGold.vue?vue&type=template&id=bae27402&scoped=true&"
import script from "./oldGold.vue?vue&type=script&lang=js&"
export * from "./oldGold.vue?vue&type=script&lang=js&"
import style0 from "./oldGold.vue?vue&type=style&index=0&id=bae27402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae27402",
  null
  
)

export default component.exports